import React from 'react'
import { Panel } from '../smart_bps/lib/components'

export default function AutoparkShowroomView() {
  return (
    <Panel header="Автопарк">
      <div className="text-center">
        <img
          src="/api/autopark/showroom_image"
          alt="Автопарк"
          style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
        />
      </div>
    </Panel>
  )
}
